<template>
  <hel-module title="产品单耗TOP(tce)" :class="scope.clsPrefix" v-loading="loading">
    <div class="progress-container" v-if="progressItems.length">
      <div class="progress-item" v-for="(item, index) in progressItems" :key="index">
        <div class="item-header">
          <span class="item-name">{{ item.name }}</span>
        </div>
        <div class="progress-bar-wrapper">
          <div class="progress-bar">
            <div class="bar-fill" :style="{ width: item.percent + '%', background: item.color }"></div>
          </div>
        </div>
        <div class="item-header">
          <span class="item-value">{{ item.radioText }}</span>
        </div>
      </div>
    </div>
    <div v-else-if="!loading" class="progress-empty">
      <i class="el-icon-data-analysis"></i>
      <span>暂无产品单耗数据</span>
    </div>
  </hel-module>
</template>

<script>
import HelModule from './common/module/index.vue'
import axios from 'axios'
import { getToken } from '@/utils/auth'
export default {
  name: 'StrategyProgress',
  components: {
    HelModule
  },
  props: {
    data: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      loading: false,
      scope: {
        clsPrefix: 'rvc-cosmoplat-workspace-strategy-progress'
      },
      progressItems: []
    }
  },
  created() {},
  mounted() {
    this.fetchUnitConsumption()
  },
  methods: {
    async fetchUnitConsumption() {
      this.loading = true
      try {
        // 查询当月：1 号 ~ 当月最后一天
        const now = new Date()
        const y = now.getFullYear()
        const m = now.getMonth()
        const pad = (n) => String(n).padStart(2, '0')
        const startDate = `${y}-${pad(m + 1)}-01`
        const endDate = `${y}-${pad(m + 1)}-${new Date(y, m + 1, 0).getDate()}`

        const response = await axios.post(
          '/energy-api/kx/guoci/product/unitConsumption/detail/product',
          {
            energyType: '2',
            startDate,
            endDate,
            no: 'SYS001'
          },
          {
            headers: {
              'Content-Type': 'application/json',
              token: getToken()
            }
          }
        )

        const res = response.data || {}
        const list = Array.isArray(res.data) ? res.data : []

        this.progressItems = list.map((item) => {
          const percentNum = parseFloat(String(item.mediumRadio).replace('%', ''))
          return {
            name: item.mediumName || '--',
            // 进度条颜色取接口 mediumColor
            color: item.mediumColor || '#4A5FF3',
            // 进度条宽度
            percent: Number.isNaN(percentNum) ? 0 : percentNum,
            // 右侧原样展示占比（如 60%）
            radioText: item.mediumRadio || '0%'
          }
        })
      } catch (error) {
        console.error('获取产品单耗数据失败:', error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$class-prefix: "rvc-cosmoplat-workspace-strategy-progress";
.#{$class-prefix} {
  .progress-container {
    height: 100%;
    padding: 10px 0;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .progress-item {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
  }
  .item-header {
    flex-shrink: 0;
    display: flex;
    gap: 8px;
    align-items: center;
    justify-content: space-between;
  }
  .item-name {
    font-family: PingFangSC-Medium;
font-weight: 600;
font-size: 12px;
color: #333333;
  }
  .item-value {
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #333333;
    font-weight: 400;
  }
  .progress-empty {
    height: 100%;
    min-height: 160px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    color: #999999;
    font-size: 12px;
    i {
      font-size: 32px;
      color: #c0c4cc;
    }
  }
  .progress-bar-wrapper {
    // width: 100%;
    flex: 1;
    margin: 0 8px;
  }
  .progress-bar {
    width: 100%;
    height: 6px;
    background: #f0f0f0;
    border-radius: 3px;
    overflow: hidden;
  }
  .bar-fill {
    height: 100%;
    border-radius: 3px;
    transition: width 0.5s ease;
  }
}
</style>
